import { render, staticRenderFns } from "./NovaPopoverChip.vue?vue&type=template&id=5ff0952a&scoped=true&lang=pug&"
import script from "./NovaPopoverChip.vue?vue&type=script&lang=js&"
export * from "./NovaPopoverChip.vue?vue&type=script&lang=js&"
import style0 from "./NovaPopoverChip.vue?vue&type=style&index=0&id=5ff0952a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff0952a",
  null
  
)

export default component.exports